// extracted by mini-css-extract-plugin
module.exports = {"object":"Object_object__5f7Oo","count":"Object_count__yJftQ","icon":"Object_icon__PyKCC","border":"Object_border__JdBY5","wrapper":"Object_wrapper__g9KRw"};